
    import { Vue,Component, Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    import Partner from '../../components/partner.vue'
    import exicon from '../../assets/expressicon'
    import FormBuilder from '../../components/common/form-builder.vue'
    const cash = namespace('cash')
    @Component({
        components: {
            PagedTable,
            Partner,
            FormBuilder
        }
    })
    export default class Home extends Vue{
        exicon:any = exicon
        payTypeIndex:number = 0
        daterange:any = [] //入库时间断
        multipleSelection:any = [] //勾选的项
        dialogStatus:boolean = false
        form:any = {
            type: '',
            month: '',
            partner: '',
            project: ''
        }
        @cash.State('pager') pager:any //表格的页码
        @cash.State('list') pagerList:any //快递员列表
        @cash.State('loading') loading:any 
        @State('dictionaries') dictionaries:any
        search:any = {
            type: '',
            partner: '',
            project: '',
            month: '',
            star: '',
            end: '',
            page: 1
        } 
        rules:any = {
            type:[{ required: true, message: '业务类型不能为空'}],
            month:[{ required: true, message: '归属月份不能为空'}],
            partner:[{ required: true, message: '快递单位不能为空'}],
            project:[{ required: true, message: '项目不能为空'}]
        }
        rechargeLoading:boolean = false //点击充值按钮的时候等待
        get formOptions(){
            return [{
                label: '业务类型',
                prop: 'type',
                type: 'slot',
                ruleType: 'text'
            },{
                label: '归属月份',
                prop: 'month',
                type: 'slot',
                ruleType: 'text'
            },{
                label: '快递单位',
                prop: 'partner',
                type: 'slot',
                ruleType: 'text',
                display: this.form.type == '增值业务'
            },{
                label: '项目',
                prop: 'project',
                type: 'slot',
                ruleType: 'text'
            }]
        }
        get tablecolumn(){
            return [
                {
                    prop: 'type',
                    name: 'type',
                    type: 'slot',
                    label: '类型',
                },
                {
                    prop: 'project',
                    name: 'project',
                    type: 'slot',
                    label: '项目',

                },
                {
                    prop: 'partner',
                    name: 'partner',
                    type: 'slot',
                    label: '快递员',

                },
                {
                    prop: 'cash',
                    type: 'text',
                    label: '金额(元)',

                },
                {
                    prop: 'month',
                    type: 'text',
                    label: '归属月份',

                },
                {
                    prop: 'ctime',
                    type: 'text',
                    label: '付款时间',

                },
                {
                    prop: 'desc',
                    type: 'slot',
                    label: '备注',
                    name: 'desc',
                    slot: 'desc',
                },
                {
                    prop: 'name',
                    name:'operation',
                    type: 'slot',
                    label: '操作',
                }
            ]
        }
        @cash.Action('getCashList') getCashList:any
        @cash.Action('modifyCash') modifyCash:any
        @Action('getDictionaries') getDictionaries:any
        @Action('getNewWaterStatus') getNewWaterStatus:any
        created(){
            this.getDictionaries()
            this.getList()
        }
        getList(){
            this.getCashList(this.search)
        }
         // 勾选前面的选项时
        multiplechange(e:any){
            this.multipleSelection = e
        }
        // 翻页
        pagechange(e:any){
            this.search.page = e[0].val
            this.getList()
        }
        // 导出数据
        exportexcel(){
            const data = this.multipleSelection
            if(data.length < 1) return this.$message.error('选择需要导出的数据')
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
                const tHeader = ['类型','项目','快递员','金额', '归属月份','备注'];
                const p = [tHeader]
                data.map((item:any)=>{
                    p.push([item.type,'未找到',item.partner ? item.partner.name : '未找到',item.cash,item.month,item.desc])
                })
                const pk = [{
                    sheetName:"付款流水统计",
                    data:p
                }];
                const extitle = `付款流水导出`
                export_json_to_excel(pk,extitle);
            })
        }
        showdialog(val){
            const { _id, cash, type, partner, month, project} = val; 
            this.form = {_id, cash, type, partner: partner._id, month, project}
            this.dialogStatus = true
        }
        // 修改备注
        async editDesc({_id, desc }:any){
            const { value } = await this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: desc,
            })
            const res = await this.modifyCash({_id, desc: value});
            if(res){
                this.getList();
            }
           
        }
        // 指定明细
        async assignDetail(){
            const res = await this.$refs.builder.submitForm();
            const { _id, cash, type, partner, month, project} = this.form;
            if(res){
                this.rechargeLoading = true;
                 const res = await this.modifyCash({_id, cash, type, partner: partner, month, project, present: 0});
                 if(res){
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.dialogStatus = false;
                 }
                this.rechargeLoading = false;
                this.getList();
                this.getNewWaterStatus();
                //  return this.$message.error(res.message);
            }
        }
        // 刷新
        refresh(){
            this.search = {
                type: '',
                partner: '',
                project: '',
                star: '',
                end: '',
                page: 1,
            } 
            this.daterange = []
            this.getList()
        }
        @Watch('daterange')
        daterangeChange(val:string,oldVal:string){
            if(val){
                this.search.star = val[0]
                this.search.end = val[1]
            }
        }
        @Watch('search.type')
        payTypeChange(val:string,oldVal:string){
            this.dictionaries.payType.forEach((item:any,index:number) => {
                if(item.name === val){
                    this.payTypeIndex = index
                    return
                }
            })
        }
        @Watch('form.type')
        payTypeChangeLayer(val:string,oldVal:string){
            this.form.project = '';
            this.dictionaries.payType.forEach((item:any,index:number) => {
                if(item.name === val){
                    this.payTypeIndex = index
                    return
                }
            })
        }
    }
